import { sva } from '@agapi/ui/panda/css';

export const authorStyles = sva({
  slots: [ 'container', 'eyebrow', 'image', 'content', 'name', 'role', 'description'],
  base: {
    container: {
      display: 'flex',
      alignItems: {
        base: 'center',
        sm: 'flex-start',
      },
      gap: '6',
      flexDirection: {
        base: 'column',
        sm: 'row',
      },
    },
    image: {
      borderRadius: 'full',
      objectFit: 'cover',
    },
    content: {
      flex: '1',
    },
    eyebrow: {
      display: 'inline-block',
      fontSize: 'md',
      pb: '2',
      opacity: '0.8',
    },
    name: {

    },
    role: {
      marginBottom: '2',
    },
    description: {
      fontSize: 'md',
      lineHeight: '1.6',
      pt: '3',
    },
  },
  variants: {
    // You can add variants here if needed
  },
});